import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import store from '@/store/store';
import CommerceProduct from '@/components/commerceProduct/commerceProduct';
import { localCurrency } from '@/plugins/currency';
import CashbackTooltip from '@/components/cashbackTooltip/cashbackTooltip';
import Loading from '@/components/loading/loading'
import { cityParser } from '@/plugins/city_parser';
import BellNotification from "@/components/bellNotification/bellNotification";

@Component({
  components: {
    CommerceProduct,
    CashbackTooltip,
    Loading,
    BellNotification
  }
})
export default class CommerceCategoryDetail extends Vue {

  @Action action_addCartProducts;
  @Action action_postCart;
  @Action action_removeCartProducts;

  @Getter getCurrentCategory;
  @Getter getCurrentSuperCategory;
  @Getter getCart;
  @Getter getCity;
  @Getter getUser;
  @Getter getIsUnderMobile;
  @Getter getIsToken: any;

  @Mutation CURRENT_CATEGORY;
  @Mutation CURRENT_PRODUCT;

  loadingProduct = -1;

  get getCurrentProducts() {
    let response = [];
    if (this.getCurrentCategory && this.getCurrentCategory.products) {
      response = this.getCurrentCategory.products.sort((a, b) => a.ordinal - b.ordinal);
    }
    return response;
  }

  _verifyActive(id) {
    if(this.getIsToken) {
      for(let item of this.getUser.notification_available_products) {
        if(item === id) {
          return true
        }    
      }
    } else {
      return false
    }
  }

  async mounted() {
    const element = document.getElementById('products');
    element.scrollTop = 0;
    this.CURRENT_PRODUCT(null);
    this.getCurrentCategory
    this.getCity
    await store.dispatch('action_getCity', 3);
    this.getCurrentSuperCategory;
  }
  
  _goBack() {
    this.$router.go(-1);
  }

  _money(value) {
    return localCurrency(value);
  }

  getDiscountedPrice(product) {
    let response = 0;
    if(product && product.price && product.discount) {
      const original = parseFloat(product.price);
      const discount = parseFloat(product.discount);
      response = original - discount;
    }
    return this._money(response);
  }

  getPromoBadge(product) {
    let response = "";
    if(product && product.current_promo && product.current_promo.promo_type && product.current_promo.promo_amount) {
      const promoType = product.current_promo.promo_type;
      const value = parseInt(product.current_promo.promo_amount);
      if(promoType === 'percentage') {
        response = `${value}% OFF`;
      } else if (promoType === 'monetary_discount') {
        response = `${this._money(value)}`;
      }
    }
    return response;
  }

  getProductCurrentQty(product) {
    let response = 0;
    if(this.getCart && this.getCart.cart_products && this.getCart.cart_products.length) {
      const index = this.getCart.cart_products.findIndex((item) => item.product_id === product.id);
      if(index !== -1) {
        response = this.getCart.cart_products[index].quantity_total;
      }
    }
    return response;
  }

  goToProfile(product) {
    if (product && product.id) {
      const productId = product.id;
      if (this.getCity && this.getCity.commercial_name) {
        const cityId = cityParser(this.getCity.commercial_name);
        this.$router.push({
          name: "productDetail",
          params: { city_id: cityId, product_id: productId }
        });
      }
    }
  }


  async _add(product, index) {
    this.loadingProduct = index;
    try {
      const requestObject = {
        products: [
          {
            product_id: product.id,
            qty: 1
          }
        ],
        commerce_id: this.getCity.id
      };
      if (this.getCart) {
        await this.action_addCartProducts(requestObject);
      } else {
        await this.action_postCart(requestObject);
      }
    } catch (error) {
      if (error.data && error.data.message) {
        this.$swal({
          title: "Error",
          text: "¡Ups! Tuvimos un problema agregando tu producto. Por favor intenta de nuevo"
        });
      }
    }
    this.loadingProduct = -1;
  }

  async _remove(product, index) {
    this.loadingProduct = index;
    try {
      const requestObject = {
        products: [
          {
            product_id: product.id,
            qty: 1,
            type: 'remove'
          }
        ],
        commerce_id: this.getCity.id
      };
      if (this.getCart) {
        await this.action_removeCartProducts(requestObject);
      } else {
        await this.action_postCart(requestObject);
      }
    } catch (error) {
      if (error.data && error.data.message) {
        this.$swal({
          title: "Error",
          text: "¡Ups! Tuvimos un problema removiendo tu producto. Por favor intenta de nuevo"
        });
      }
    }
    this.loadingProduct = -1;
  }

  _truncate(value: string) {
    let response = value;
    let maxChars = 30;
    if(this.getIsUnderMobile) {
      maxChars = 25;
    }
    if(value && value.length && value.length > maxChars) {
      response = value.substr(0, maxChars) + "...";
    }
    return response;
  }

}